module.exports = __webpack_public_path__ + "img/tcApi_step1.9af91139.png";